import { useLocation, useNavigate, useParams } from 'react-router';
import CustomBreadcrumb from '../../../components/CustomBreadcrumb';
import { CustomButton } from '../../../components/CustomButton';
import TableActionsContainer from '../../../components/CustomTable/TableActionsContainer';
import { Text } from '../../../components/Text';
import { useDispatch, useSelector } from 'react-redux';
import CustomDropdown from '../../../components/common/CustomDropdown';
import CustomInputText from '../../../components/common/CustomInputText';

import { useForm, Controller } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { useRef } from 'react';
import Loader from '../../../components/Loader';
import { Toast } from 'primereact/toast';
import {
  changeTemplateMode,
  resetSelectedTemplate,
} from '../../../reducers/wca/template/template-slices';
import {
  addTemplate,
  getTemplatesbyId,
  getTemplatesbyappId,
  updateTemplate,
} from '../../../reducers/templateReducer/templateActions';

import TemplatePreview from '../../../components/TemplatePreviewWCA';
import {
  wcaLanguageOptions,
  headerTypes,
  buttonTypes,
  tempCategories,
  formateMessageInput,
  extractVariablesFormMessage,
  tempProductButons,
  validateMediaSize,
  isVariableExist,
  WCAtempleteVariablesType,
  formatBodyContent,
  formatVariableArr,
  isValidURL,
  SPAM_KEYWORDS,
  SPAM_SUGGESTIONS,
  checkForSpam,
  wcaTempCategories,
  MESSAGE_TYPE_CONFIG,
  wcaHeaderTypes,
  wcaMediaTypes,
  buildWCAHeaderComponent,
  buildWCABodyComponent,
  buildWCAFooterComponent,
  buildWCAButtonsComponent,
  buildWCAMediaCarouselComponent,
  buildWCAProductCarouselComponent,
  buildWCAProductComponent,
  buildWCAAuthenticationComponent,
} from '../../../utils/templateUtils';
import axios from 'axios';
import { isValidPhoneNumber } from 'react-phone-number-input';
import CONSTANTS from '../../../config/Constants';
import CustomSaveModel from '../../../components/CustomeSaveModel';
import * as Messag from '../../../config/ToastMessage';
import modulesName from '../../../roles/modulesName';
import permissions from '../../../roles/permissions';
import { useUtility } from '../../../context/UtilityContext';
import { convertToWATemplate } from './ConvertorTemplate';
import { createTemplate_WCA } from '../../../reducers/wca/template/template-action';
import SelectCards from './components/Select-cards';
import MarketingStandardTemplate from './Marketing-templates/Marketing-standard-template';
import MarketingTemplates from './Marketing-templates';
import UtilityTemplates from './Utility-templates';
import AuthenticationTemplates from './Authentication-template';

function WCANewTemplate() {
  const [showSpamSuggestions, setShowSpamSuggestions] = useState(false);
  const location = useLocation();
  const { id } = useParams();
  const templateLibraryTemplate = location.state?.templateLibraryTemplate || null;
  const [file, setFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [videoPreview, setVideoPreview] = useState(null);
  const [documentPreview, setDocumentPreview] = useState(null);
  const [templateButtons, setTempBtn] = useState([]);
  const [tempVariables, setTempvariables] = useState([]);
  const [showEmoji, setShowEmoji] = useState(false);
  const [seletedButtonType, setSelectedButtonType] = useState('none');
  const { templateMode, loading } = useSelector((state) => state.wcaMessageTemplate);
  const [showSave, setShowSave] = useState(false);
  const [templateConfig, setTemplateConfig] = useState({});
  const [editTemplate, setEditTemplate] = useState(null);

  const navigate = useNavigate();
  const toast = useRef(null);
  const dispatch = useDispatch();
  const mediaFileRef = useRef();
  const menuRef = useRef(null);
  const textAreaRef = useRef(null);

  const { setAlert, navigation } = useUtility();
  const [messageVarCount, setMessageVarCount] = useState(1);
  const { selectedMetadataId } = useUtility();

  const messsageVariables = [
    {
      label: 'Customer Name',
      value: '{{customername}}',
      command: (e) => {
        addVariablesClick(e.item.value);
      },
    },
    {
      label: 'Customer Mobile No',
      value: '{{customermobile}}',
      command: (e) => {
        addVariablesClick(e.item.value);
      },
    },
    {
      label: 'Customer Email',
      value: '{{customeremail}}',
      command: (e) => {
        addVariablesClick(e.item.value);
      },
    },
    {
      label: 'Meeting Name',
      value: `{{meetingname}}`,
      command: (e) => {
        addVariablesClick(e.item.value);
      },
    },
    {
      label: 'Meeting Time',
      value: `{{time}}`,
      command: (e) => {
        addVariablesClick(e.item.value);
      },
    },
    {
      label: 'Meeting Date',
      value: `{{date}}`,
      command: (e) => {
        addVariablesClick(e.item.value);
      },
    },
    {
      label: 'Message',
      value: `{{message${messageVarCount}}}`,
      command: (e) => {
        addVariablesClick(e.item.value);
        setMessageVarCount((prev) => prev + 1);
      },
    },
  ];
  const { accesskey } = useSelector((state) => state.authenticate);
  useEffect(() => {
    return () => {
      setAlert(false);
    };
  }, []);
  const breadcumbHome = { label: 'Templates', url: '/campaign-templates/list' };
  const breadcumbList = [
    {
      label: `${templateMode == 'update' ? 'Update' : 'New'} Template`,
      url: '#',
    },
  ];

  const handleDeleteVariable = (idToDelete) => {
    const input = textAreaRef.current;
    const currentContent = watch('content') || '';
    if (!input) return;

    const variableToDelete = tempVariables.find((v) => v.id === idToDelete);
    if (!variableToDelete) return;

    const updatedVars = tempVariables.filter((v) => v.id !== idToDelete);
    setTempvariables(updatedVars);

    const updatedContent = currentContent
      .replaceAll(variableToDelete.variableName, '')
      .replace(/\s{2,}/g, ' ')
      .trim();

    textAreaRef.current.value = updatedContent;
    textAreaRef.current.focus();
    textAreaRef.current.setSelectionRange(updatedContent.length, updatedContent.length);

    setValue('content', updatedContent);
  };

  const defaultValues = {
    elementName: '',
    languageCode: 'en',

    category: 'MARKETING',
    messageType: 'STANDARD',

    carouselType: 'MEDIA',
    productCTAType: 'VIEW', // VIEW | CUSTOM
    productCTA: {
      text: '',
      url: '',
    },

    productType: 'CATALOG',

    productCards: [],

    headerType: 'NONE',
    mediaType: null,

    header: '',
    mediaId: '',
    // vertical: '',
    content: '',
    example: '',
    footer: '',

    securityDisclaimer: true,
    expirationWarning: true,
    authCTA: 'COPY_CODE',
  };

  const getLibraryMessageType = (template) => {
    if (template?.category === 'AUTHENTICATION') {
      return 'DEFAULT';
    }

    if (template?.topic === 'CALL_PERMISSIONS' || template?.usecase === 'CALL_PERMISSION_REQUEST') {
      return 'CALL_PERMISSION';
    }

    return 'STANDARD';
  };

  const formatLibraryBodyForEditor = (body = '') => {
    let variableIndex = 1;

    return body.replace(/{{\d+}}/g, () => `{{message${variableIndex++}}}`);
  };

  const buildLibraryVariables = (bodyParams = []) => {
    return bodyParams.map((value, index) => ({
      id: Math.floor(1000 + Math.random() * 9000),
      variableName: `{{message${index + 1}}}`,
      variableValue: value || '',
      variableType: 'customNote',
    }));
  };

  const normalizeLibraryButtons = (buttons = []) => {
    return buttons.map((button) => ({
      ...button,
      id: Math.floor(1000 + Math.random() * 9000),
      isSaved: button?.type === 'QUICK_REPLY',
    }));
  };
  //function form get error message
  const getFormErrorMessage = (name) => {
    return errors[name] && <small className="p-error">{errors[name].message}</small>;
  };
  const {
    control,
    formState: { errors, dirtyFields },
    handleSubmit,
    watch,
    reset,
    setValue,
  } = useForm({ defaultValues });

  const watchHeaderType = watch('headerType');
  const watchHeader = watch('header');
  const watchFooter = watch('footer');
  const watchContent = watch('content');
  const watchCategory = watch('category');
  const watchMessageType = watch('messageType');
  const watchMediaType = watch('mediaType');

  const messageTypeOptions = MESSAGE_TYPE_CONFIG[watchCategory] || [];

  const prevCategory = useRef(watchCategory);
  const prevMessageType = useRef(watchMessageType);

  useEffect(() => {
    if (prevCategory.current !== watchCategory || prevMessageType.current !== watchMessageType) {
      reset({
        elementName: '',
        languageCode: '',
        category: watchCategory,
        messageType: watchMessageType,
        footer: '',
      });

      setTempBtn([]);
      setTempvariables([]);
      setFile(null);
    }

    prevCategory.current = watchCategory;
    prevMessageType.current = watchMessageType;
  }, [watchCategory, watchMessageType]);

  const setFormValueFromLibraryTemplate = (template) => {
    if (!template) return;

    const messageType = getLibraryMessageType(template);
    const content = formatLibraryBodyForEditor(template?.body || '');
    const mappedVariables = buildLibraryVariables(template?.body_params || []);
    const mappedButtons = normalizeLibraryButtons(template?.buttons || []);

    prevCategory.current = template?.category || defaultValues.category;
    prevMessageType.current = messageType;

    reset({
      ...defaultValues,
      elementName: template?.name || '',
      languageCode: template?.language || 'en',
      category: template?.category || defaultValues.category,
      messageType,
      headerType: template?.header ? 'TEXT' : 'NONE',
      header: template?.header || '',
      content,
      footer: template?.footer || '',
    });

    setTempvariables(mappedVariables);
    setMessageVarCount(mappedVariables.length + 1);
    setTempBtn(mappedButtons);
    setSelectedButtonType(mappedButtons[0]?.type || 'none');
    setEditTemplate(null);
    setFile(null);
    setImagePreview(null);
    setVideoPreview(null);
    setDocumentPreview(null);
  };

  const previewFile = (e) => {
    // Reading New File (open file Picker Box)
    const reader = new FileReader();
    // Gettting Selected File (user can select multiple but we are choosing only one)
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      reader.readAsDataURL(selectedFile);
    }
    // As the File loaded then set the stage as per the file type
    reader.onload = (readerEvent) => {
      if (selectedFile.type.includes('image')) {
        setImagePreview(readerEvent.target.result);
      } else if (selectedFile.type.includes('video')) {
        setVideoPreview(readerEvent.target.result);
      } else if (selectedFile.type.includes('pdf')) {
        setDocumentPreview(readerEvent.target.result);
      }
    };
  };

  const resetHeader = () => {
    watchHeader && setValue('header', '');
    file && setFile(null);
    imagePreview && setImagePreview(null);
    videoPreview && setVideoPreview(null);
    documentPreview && setDocumentPreview(null);
  };

  const handleTemplateTypeRadioSelect = (e) => {
    resetHeader();
    setValue('headerType', e.value.value);
  };

  const addVariablesClick = (varlabel) => {
    const input = textAreaRef.current;
    const textAreavalue = watchContent || '';
    if (!input) return;
    const { selectionStart, selectionEnd } = input;
    const cleanVar = varlabel.replace(/[{}]/g, '').toLowerCase();
    const formattedVar = `{{${cleanVar}}}`;
    //     const newValue =
    //       textAreavalue.slice(0, selectionStart) + varlabel + textAreavalue.slice(selectionEnd);

    const newValue =
      textAreavalue.slice(0, selectionStart) + formattedVar + textAreavalue.slice(selectionEnd);

    // Set the cursor position after the inserted text
    const newPosition = selectionStart + varlabel.length;
    textAreaRef.current.value = newValue;
    input.setSelectionRange(newPosition, newPosition);
    input.focus();

    // let newVarObj = {
    //   id: Math.floor(1000 + Math.random() * 9000),
    //   variableName: `${varlabel}`,
    //   variableValue: '',
    //   variableType: varlabel.includes('customer')
    //     ? WCAtempleteVariablesType[varlabel.toLowerCase()]
    //     : 'customnote',
    // };
    let newVarObj = {
      id: Math.floor(1000 + Math.random() * 9000),
      variableName: formattedVar, // always lowercase now
      variableValue: '',
      variableType: WCAtempleteVariablesType[formattedVar] || 'customnote',
    };
    if (!isVariableExist(newVarObj, tempVariables)) {
      setTempvariables((prev) => [...prev, newVarObj]);
    }
    setValue('content', newValue);
  };
  const handleEditVariable = (e, id) => {
    let updateVariableData = tempVariables.map((item) => {
      if (item.id !== id) return item;
      else return { ...item, variableValue: e.target.value };
    });
    setTempvariables(updateVariableData);
  };
  const handleButtonEdit = (e, id, key) => {
    let updatedButtons = templateButtons.map((btn) => {
      if (btn.id !== id) return btn;
      else
        return {
          ...btn,
          [`${key}`]: key == 'phone_number' ? e : e.target.value,
        };
    });
    setTempBtn(updatedButtons);
  };

  const formatButtonData = (buttons) => {
    let buttonsData = buttons.map((btn) => {
      let newBtn = { ...btn, text: btn.text.trim() };
      delete newBtn.id;
      delete newBtn.isSaved;
      return newBtn;
    });

    return buttonsData;
  };

  const handleEmojiClick = (e) => {
    const emoji = e.native;
    const input = textAreaRef.current;
    const textAreavalue = watchContent || '';
    if (!input) return;

    const { selectionStart, selectionEnd } = input;
    const newValue =
      textAreavalue.substring(0, selectionStart) + emoji + textAreavalue.substring(selectionEnd);
    // Set the cursor position after the inserted text
    const newPosition = selectionStart + emoji.length;
    textAreaRef.current.value = newValue;
    input.setSelectionRange(newPosition, newPosition);
    input.focus();
    // Move caret position after the inserted emoji
    // input.selectionStart = input.selectionEnd = selectionStart + emoji.length;
    setValue('content', newValue);
  };

  const saveTemplate = (configData) => {
    setShowSave(false);
    if (templateMode === 'create' || templateMode == 'clone') {
      dispatch(createTemplate_WCA({ metadataid: selectedMetadataId, data: configData }))
        .unwrap()
        .then(() => {
          toast.current.show({
            severity: 'success',
            detail: Messag.Add_Template_ToastSuccessMessage,
          });
          // ✅ Reset React Hook Form
          reset(defaultValues);

          // ✅ Reset local states
          setFile(null);
          setImagePreview(null);
          setVideoPreview(null);
          setDocumentPreview(null);
          setTempBtn([]);
          setTempvariables([]);
          setShowEmoji(false);
          setSelectedButtonType('none');
          setTemplateConfig({});
          setEditTemplate(null);
          setShowSave(false);
          navigate(`/campaign-templates/list`);
        })
        .catch((err) => {
          console.error('err', err);
          toast.current.show({
            severity: 'error',
            detail: err,
          });
        });
    }
    // else if (templateMode === 'update') {
    //   dispatch(updateTemplate({ configData, media: file, id }))
    //     .unwrap()
    //     .then(() => {
    //       toast.current.show({
    //         severity: 'success',
    //         detail: Messag.Update_Template_ToastSuccessMessage,
    //       });
    //       navigate(`/wca-campaign-templates/list`);
    //     })
    //     .catch((err) => {
    //       toast.current.show({
    //         severity: 'error',
    //         detail: err.message,
    //       });
    //     });
    // }
  };

  const onSubmit = async (data) => {
    const { phoneCount, urlCount, quickReplyCount, total, maxQuickReplies } = getButtonTypeCounts();

    if (total > 10) {
      toast.current.show({
        severity: 'error',
        detail: "You can't add more than 10 buttons.",
      });
      return;
    }

    if (phoneCount > 1 || urlCount > 2 || quickReplyCount > maxQuickReplies) {
      toast.current.show({
        severity: 'error',
        detail: 'Button configuration is invalid.',
      });
      return;
    }

    // ✅ Validate Quick Replies
    const quickReplyButtons = templateButtons.filter((btn) => btn.type === 'QUICK_REPLY');
    if (quickReplyButtons.length > 0) {
      const hasEmptyQuickReply = quickReplyButtons.some((btn) => btn.text.trim() === '');
      if (hasEmptyQuickReply) {
        toast.current.show({
          severity: 'warn',
          detail: "Please add text for quick reply buttons, it can't be empty.",
        });
        return;
      }
    }

    // ✅ Validate Phone Numbers
    const phoneButtons = templateButtons.filter((btn) => btn.type === 'PHONE_NUMBER');
    if (phoneButtons.some((btn) => !btn.text?.trim() || !isValidPhoneNumber(btn.phone_number))) {
      toast.current.show({
        severity: 'warn',
        detail: 'Please provide valid phone number and label.',
      });
      return;
    }

    // ✅ Validate URLs
    const urlButtons = templateButtons.filter((btn) => btn.type === 'URL');
    if (urlButtons.some((btn) => !btn.text?.trim() || !isValidURL(btn.url))) {
      toast.current.show({
        severity: 'warn',
        detail: 'Please provide valid URL and label.',
      });
      return;
    }

    if (watchHeaderType === 'MEDIA' && !file) {
      toast.current.show({
        severity: 'warn',
        detail: 'Please selece a media file.',
      });
      setShowSave(false);
      return;
    }
    if (watchHeaderType === 'MEDIA') {
      let { isValid, acceptedSize } = validateMediaSize(file.size, watchMediaType?.toLowerCase());

      if (!isValid) {
        toast.current.show({
          severity: 'warn',
          detail: `Please select ${watchMediaType}, less than ${acceptedSize} MB in size`,
        });
        setShowSave(false);
        return;
      }
    }
    const { content, footer } = data;

    let isCampainTypeProduct = false;
    templateButtons?.forEach((btn) => {
      if (btn?.text === 'Menu') {
        isCampainTypeProduct = true;
        return;
      }
    });

    let components = [];

    const bodyComponent = buildWCABodyComponent(content, tempVariables);

    if (data.messageType === 'CAROUSEL') {
      let carouselComponent = null;

      if (data.carouselType === 'MEDIA') {
        carouselComponent = await buildWCAMediaCarouselComponent(
          data.carouselCards,
          dispatch,
          selectedMetadataId,
        );
      }

      if (data.carouselType === 'PRODUCT') {
        carouselComponent = buildWCAProductCarouselComponent(
          data.productCards,
          data.productCTAType,
          data.productCTA,
        );
      }

      components = [bodyComponent, carouselComponent];
    } else if (data.messageType === 'PRODUCT') {
      components = buildWCAProductComponent(data, tempVariables);
    } else if (data.messageType === 'CALL_PERMISSION') {
      const callPermissionComponent = {
        type: 'call_permission_request',
      };

      components = [bodyComponent, callPermissionComponent];
    } else if (data.category === 'AUTHENTICATION') {
      components = buildWCAAuthenticationComponent(data);
    } else {
      // STANDARD FLOW
      const headerComponent = await buildWCAHeaderComponent(
        { ...data, file },
        dispatch,
        selectedMetadataId,
      );

      const footerComponent = buildWCAFooterComponent(footer);
      const buttonsComponent = buildWCAButtonsComponent(templateButtons);

      components = [headerComponent, bodyComponent, footerComponent, buttonsComponent].filter(
        Boolean,
      );
    }

    const configData = {
      name: data.elementName,
      category: data.category,
      language: data.languageCode,
      parameter_format: 'named',
      components,
    };

    // consoling the data and returning after this for testing purpose

    // return;
    setTemplateConfig(configData);
    setShowSave(true);
  };

  const setFormValueOnUpdateMode = (selectedTemplate, mode) => {
    const {
      containerMeta,
      elementName,
      languageCode,
      category,
      headerType,
      variables,
      id,
      // vertical,
    } = selectedTemplate;
    const { data, header, footer, sampleMedia, buttons, mediaId } = JSON.parse(containerMeta);
    if (headerType.toUpperCase() !== 'TEXT') {
      axios
        .get(
          `https://api.gupshup.io/wa/${selectedTemplate.appId}/wa/media/${mediaId}?download=false`,
          { responseType: 'blob' },
        )
        .then((res) => {
          return res.data;
        })
        .then((e) => {
          return new File([e], `file.${e.type.split(`/`)[1]}`, {
            type: e.type,
          });
        })
        .then((e) => {
          const reader = new FileReader();
          const selectedFile = e;
          if (selectedFile) {
            setFile(selectedFile);
            reader.readAsDataURL(selectedFile);
          }
          reader.onload = (readerEvent) => {
            if (selectedFile.type.includes('image')) {
              setImagePreview(readerEvent.target.result);
            } else if (selectedFile.type.includes('video')) {
              setVideoPreview(readerEvent.target.result);
            } else if (selectedFile.type.includes('pdf')) {
              setDocumentPreview(readerEvent.target.result);
            }
          };
        })
        .catch((e) => {
          console.log(e);
        });
    }

    if (mode == 'clone') {
      setValue('elementName', elementName + '_copy');
    } else {
      setValue('elementName', elementName);
    }
    setValue('category', category);
    setValue('languageCode', languageCode);
    setValue('headerType', headerType);
    setValue('header', header || '');
    setValue('footer', footer || '');
    // setValue('vertical', vertical);
    setValue('mediaId', sampleMedia);
    let messStr = data;
    if (variables && variables.length != 0) {
      let localMessageVarCount = 1;
      let templateVars = [];
      variables?.forEach((item) => {
        messStr = messStr.replace(
          item.variableName,
          `{{${
            item.variableType == 'customNote' ? `message${localMessageVarCount}` : item.variableType
          }}}`,
        );
        let varObj = {
          ...item,
          variableName:
            item.variableType == 'customNote'
              ? `{{message${localMessageVarCount++}}}`
              : `{{${item.variableType}}}`,
          id: Math.floor(1000 + Math.random() * 9000),
          variableValue: item.variableValue || '',
        };
        if (!isVariableExist(varObj, templateVars)) {
          templateVars.push(varObj);
        }
      });
      setTempvariables(templateVars);
      setMessageVarCount(localMessageVarCount);
    }
    let btnType = buttons[0]?.type;
    if (btnType) setSelectedButtonType(btnType);
    else setSelectedButtonType('none');

    if (buttons && buttons.length != 0) {
      if (buttons[0]?.type === 'PHONE_NUMBER') {
        let temp = buttons[0]?.['phone_number'].replace('+', '');
        setValue(btnType.toUpperCase(), '+' + temp, {
          shouldValidate: true,
        });
      }
      if (buttons[0]?.type === 'URL') {
        setValue('url', buttons[0]?.['url'], { shouldValidate: true });
      }

      let tempBtns = buttons.map((btn) => {
        return {
          ...btn,
          id: Math.floor(1000 + Math.random() * 9000),
          isSaved: btnType == 'QUICK_REPLY' ? true : false,
        };
      });
      setTempBtn(tempBtns);
    }
    setValue('content', messStr);
  };

  const handleReset = () => {
    if (templateMode == 'create') {
      reset();
      setTempBtn([]);
      setTempvariables([]);
      setFile(null);
      setSelectedButtonType('none');
    } else if (editTemplate != null) {
      setFormValueOnUpdateMode(editTemplate);
    } else {
      setValue('headerType', 'TEXT');
      setValue('languageCode', 'en');
      setValue('category', 'MARKETING');
    }
  };

  useEffect(() => {
    let allvariablesInContent = extractVariablesFormMessage(watchContent);
    let filterTempVars = [];
    let newVars = [];

    for (let i = 0; i < allvariablesInContent.length; i++) {
      if (!isVariableExist(allvariablesInContent[i], tempVariables)) {
        newVars.push(allvariablesInContent[i]);
      }
    }
    for (let i = 0; i < tempVariables.length; i++) {
      if (isVariableExist(tempVariables[i], allvariablesInContent)) {
        filterTempVars.push(tempVariables[i]);
      }
    }
    setTempvariables([...filterTempVars, ...newVars]);
    if (watchContent == undefined || !watchContent.trim()) setMessageVarCount(1);
  }, [watchContent]);

  useEffect(() => {
    if (id != undefined) {
      dispatch(getTemplatesbyappId(id))
        .unwrap()
        .then((selectedTemplate) => {
          let pathNameArr = location.pathname.split('/');
          let templateMode = pathNameArr[pathNameArr.length - 1];
          dispatch(changeTemplateMode(templateMode));
          setFormValueOnUpdateMode(selectedTemplate, templateMode);
          setEditTemplate(selectedTemplate);
        })
        .catch((err) => {
          console.log('errr', err);
        });
    } else {
      dispatch(changeTemplateMode('create'));

      if (templateLibraryTemplate) {
        setFormValueFromLibraryTemplate(templateLibraryTemplate);
      } else {
        setValue('headerType', 'TEXT');
        setValue('languageCode', 'en');
        setValue('category', 'MARKETING');
      }
    }
    return () => {
      dispatch(resetSelectedTemplate());
    };
  }, [dispatch, id, location.pathname, templateLibraryTemplate]);

  const SaveModel = () => {
    return (
      <CustomSaveModel
        showSave={showSave}
        header={alertText()}
        dialogFooter={dialogFooter}
        onHide={onHide}
      />
    );
  };
  const alertText = () => {
    return <div>{CONSTANTS.TEMPLATE_SAVE_CONFIRMATION}</div>;
  };
  const dialogFooter = () => {
    return (
      <div className="flex justify-content-end ">
        <CustomButton
          label="Cancel"
          type="button"
          varient="cancel"
          autofocus={true}
          onClick={() => {
            setShowSave(false);
          }}
        />
        <CustomButton
          label="Confirm"
          type="button"
          varient="filled"
          onClick={() => saveTemplate(templateConfig)}
        />
      </div>
    );
  };
  const onHide = () => {
    setShowSave(false);
  };

  const handleQuickReplyChange = (e, id) => {
    if (!id) return;
    const val = e.target.value;
    if (val.length > 17) {
      toast.current.show({
        severity: 'warn',
        detail: 'Button length should be less than 17',
      });
      return;
    }

    const custQuickReply = templateButtons?.map((quickBtn) => {
      if (quickBtn.id === id) {
        return {
          ...quickBtn,
          text: val,
        };
      }
      return quickBtn;
    });

    setTempBtn(custQuickReply);
  };

  const addQuickReplyBtn = () => {
    const { quickReplyCount, maxQuickReplies, total } = getButtonTypeCounts();

    if (total >= 10) {
      toast.current.show({
        severity: 'warn',
        detail: 'You can only add up to 10 buttons in total.',
      });
      return;
    }

    if (quickReplyCount >= maxQuickReplies) {
      toast.current.show({
        severity: 'warn',
        detail: `You can only add ${maxQuickReplies} Quick Reply buttons.`,
      });
      return;
    }

    const custQuickReply = {
      id: Math.floor(1000 + Math.random() * 9000),
      text: '',
      type: 'QUICK_REPLY',
      isSaved: true,
    };
    setTempBtn((prev) => [...prev, custQuickReply]);
  };

  const getButtonTypeCounts = () => {
    let phoneCount = 0;
    let urlCount = 0;
    let quickReplyCount = 0;

    templateButtons.forEach((btn) => {
      switch (btn.type) {
        case 'PHONE_NUMBER':
          phoneCount++;
          break;
        case 'URL':
          urlCount++;
          break;
        case 'QUICK_REPLY':
          quickReplyCount++;
          break;
      }
    });

    return {
      phoneCount,
      urlCount,
      quickReplyCount,
      total: phoneCount + urlCount + quickReplyCount,
      maxQuickReplies: 10 - phoneCount - urlCount,
      totalCTA: phoneCount + urlCount,
    };
  };

  const handleAddCTA = (btnType) => {
    const { phoneCount, urlCount, total } = getButtonTypeCounts();

    if (total >= 10) {
      toast.current.show({
        severity: 'warn',
        detail: 'You can only add up to 10 buttons.',
      });
      return;
    }

    if (btnType === 'PHONE_NUMBER' && phoneCount >= 1) {
      toast.current.show({
        severity: 'warn',
        detail: 'Only 1 phone number button allowed.',
      });
      return;
    }

    if (btnType === 'URL' && urlCount >= 2) {
      toast.current.show({
        severity: 'warn',
        detail: 'Only 2 URL buttons allowed.',
      });
      return;
    }

    const buttonObj = {
      id: Math.floor(1000 + Math.random() * 9000),
      text: '',
      isSaved: false,
      type: btnType,
      ...(btnType === 'PHONE_NUMBER' && { phone_number: '' }),
      ...(btnType === 'URL' && { url: '' }),
    };

    setTempBtn((prev) => [...prev, buttonObj]);
  };

  const removeButton = (id) => {
    if (!id) return;
    setTempBtn((prev) => prev.filter((btn) => btn.id !== id));
  };

  useEffect(() => {
    const firstType = MESSAGE_TYPE_CONFIG[watchCategory]?.[0]?.value;

    if (firstType) {
      setValue('messageType', firstType);
    }
  }, [watchCategory]);

  return (
    <div style={{ backgroundColor: '#F8F9FE' }}>
      <Loader visible={loading} />
      <Toast ref={toast} />
      <CustomBreadcrumb home={breadcumbHome} itemslist={breadcumbList} />
      <SaveModel />
      <form
        onSubmit={handleSubmit(onSubmit)}
        onChange={() => {
          setAlert(true);
        }}
      >
        <div className="m-3">
          <TableActionsContainer>
            <div className="flex justify-content-between align-items-center gap-3 flex-wrap">
              <Text type={'heading'}>Template Information</Text>
              <div className="flex gap-2">
                <CustomButton
                  varient="text"
                  type="button"
                  label={'Back'}
                  onClick={() => navigation('/campaign-templates/list')}
                />
                <CustomButton
                  varient="outline"
                  type="button"
                  label={'Reset'}
                  onClick={handleReset}
                />
                {accesskey[modulesName.TICKET]?.includes(
                  templateMode == 'update' ? permissions.UPDATE : permissions.CREATE,
                ) && (
                  <CustomButton
                    varient="filled"
                    type="submit"
                    label={templateMode == 'update' ? 'Update' : 'Save'}
                  />
                )}
              </div>
            </div>
          </TableActionsContainer>
        </div>
        <div className="px-3 mb-3 flex justify-content-between gap-3 flex-wrap-reverse">
          <div className="p-3 min-w-min lg:w-7 xl:w-7 form-container">
            <div className=" flex flex-wrap gap-3 flex-grow-1 ">
              <div className="w-full flex flex-column lg:flex-row flex-wrap gap-3 lg:gap-2 ">
                <div className="flex-1">
                  <CustomInputText
                    name="elementName"
                    label="Template Name"
                    control={control}
                    placeholer="Enter Template Name"
                    required={true}
                    maxLength={50}
                    helpingText={'( use only lowercase letters, numbers, and underscores .)'}
                    rules={{
                      pattern: {
                        value: /^[a-z0-9_]*$/,
                        message: 'Only small letters, numbers and underscore are allowed',
                      },
                    }}
                    capitalize={false}
                  />
                  {getFormErrorMessage('elementName')}
                </div>
                <div className="flex-1">
                  <CustomDropdown
                    name="languageCode"
                    label="Language"
                    control={control}
                    isMandatory={true}
                    optionLabel="key"
                    optionValue="value"
                    options={wcaLanguageOptions}
                    placeholder="Select"
                  />
                  {getFormErrorMessage('languageCode')}
                </div>
              </div>
              <div className="w-full flex flex-column lg:flex-row flex-wrap gap-3 lg:gap-2">
                <div className="flex-1">
                  <label className="form-label">Category</label>

                  <SelectCards
                    control={control}
                    name="category"
                    options={wcaTempCategories}
                    defaultValue="MARKETING"
                  />
                </div>
              </div>

              {watchCategory === 'MARKETING' && (
                <MarketingTemplates
                  messageType={watchMessageType}
                  control={control}
                  watch={watch}
                  setValue={setValue}
                  file={file}
                  setFile={setFile}
                  previewFile={previewFile}
                  setImagePreview={setImagePreview}
                  setVideoPreview={setVideoPreview}
                  setDocumentPreview={setDocumentPreview}
                  validateMediaSize={validateMediaSize}
                  getFormErrorMessage={getFormErrorMessage}
                  textAreaRef={textAreaRef}
                  SPAM_SUGGESTIONS={SPAM_SUGGESTIONS}
                  showSpamSuggestions={showSpamSuggestions}
                  setShowSpamSuggestions={setShowSpamSuggestions}
                  checkForSpam={checkForSpam}
                  messsageVariables={messsageVariables}
                  menuRef={menuRef}
                  showEmoji={showEmoji}
                  setShowEmoji={setShowEmoji}
                  handleEmojiClick={handleEmojiClick}
                  tempVariables={tempVariables}
                  handleEditVariable={handleEditVariable}
                  handleDeleteVariable={handleDeleteVariable}
                  watchContent={watchContent}
                  templateButtons={templateButtons}
                  setTempBtn={setTempBtn}
                  handleQuickReplyChange={handleQuickReplyChange}
                  handleButtonEdit={handleButtonEdit}
                  removeButton={removeButton}
                  addQuickReplyBtn={addQuickReplyBtn}
                  handleAddCTA={handleAddCTA}
                  getButtonTypeCounts={getButtonTypeCounts}
                />
              )}

              {watchCategory === 'UTILITY' && (
                <UtilityTemplates
                  messageType={watchMessageType}
                  control={control}
                  watch={watch}
                  setValue={setValue}
                  file={file}
                  setFile={setFile}
                  videoPreview={videoPreview}
                  documentPreview={documentPreview}
                  imagePreview={imagePreview}
                  previewFile={previewFile}
                  validateMediaSize={validateMediaSize}
                  getFormErrorMessage={getFormErrorMessage}
                  textAreaRef={textAreaRef}
                  SPAM_SUGGESTIONS={SPAM_SUGGESTIONS}
                  showSpamSuggestions={showSpamSuggestions}
                  setShowSpamSuggestions={setShowSpamSuggestions}
                  checkForSpam={checkForSpam}
                  messsageVariables={messsageVariables}
                  menuRef={menuRef}
                  showEmoji={showEmoji}
                  setShowEmoji={setShowEmoji}
                  handleEmojiClick={handleEmojiClick}
                  tempVariables={tempVariables}
                  handleEditVariable={handleEditVariable}
                  handleDeleteVariable={handleDeleteVariable}
                  watchContent={watchContent}
                  templateButtons={templateButtons}
                  setTempBtn={setTempBtn}
                  handleQuickReplyChange={handleQuickReplyChange}
                  handleButtonEdit={handleButtonEdit}
                  removeButton={removeButton}
                  addQuickReplyBtn={addQuickReplyBtn}
                  handleAddCTA={handleAddCTA}
                  getButtonTypeCounts={getButtonTypeCounts}
                />
              )}

              {watchCategory === 'AUTHENTICATION' && (
                <AuthenticationTemplates
                  messageType={watchMessageType}
                  control={control}
                  watch={watch}
                  setValue={setValue}
                  file={file}
                  setFile={setFile}
                  previewFile={previewFile}
                  validateMediaSize={validateMediaSize}
                  getFormErrorMessage={getFormErrorMessage}
                  textAreaRef={textAreaRef}
                  SPAM_SUGGESTIONS={SPAM_SUGGESTIONS}
                  showSpamSuggestions={showSpamSuggestions}
                  setShowSpamSuggestions={setShowSpamSuggestions}
                  checkForSpam={checkForSpam}
                  messsageVariables={messsageVariables}
                  menuRef={menuRef}
                  showEmoji={showEmoji}
                  setShowEmoji={setShowEmoji}
                  handleEmojiClick={handleEmojiClick}
                  tempVariables={tempVariables}
                  handleEditVariable={handleEditVariable}
                  handleDeleteVariable={handleDeleteVariable}
                  watchContent={watchContent}
                  templateButtons={templateButtons}
                  setTempBtn={setTempBtn}
                  handleQuickReplyChange={handleQuickReplyChange}
                  handleButtonEdit={handleButtonEdit}
                  removeButton={removeButton}
                  addQuickReplyBtn={addQuickReplyBtn}
                  handleAddCTA={handleAddCTA}
                  getButtonTypeCounts={getButtonTypeCounts}
                />
              )}
            </div>
          </div>
          <div className="py-3 flex-grow-1">
            <div className="flex justify-content-center sticky top-0">
              <TemplatePreview
                category={watchCategory}
                messageType={watchMessageType}
                header={watchHeader}
                footer={watchFooter}
                buttons={templateButtons}
                content={formateMessageInput(watchContent, 'preview', tempVariables)}
                videoPreview={videoPreview}
                documentPreview={documentPreview}
                imagePreview={imagePreview}
                file={file}
                carouselType={watch('carouselType')}
                carouselCards={watch('carouselCards')}
                productCards={watch('productCards')}
                productCTAType={watch('productCTAType')}
                productCTA={watch('productCTA')}
                productType={watch('productType')}
                productThumbnail={watch('productThumbnail')}
                watch={watch}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default WCANewTemplate;
